import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Grid, Breadcrumb } from "semantic-ui-react";
import UiMeet3dNav from "~/modules/UiMeet3d/constants/UiMeet3dNav";
import "~/applications/panel/styles/TourHeader.less";

@observer
class UiMeet3dHeader extends Component {
  getSections() {
    const { t, active } = this.props;

    const baseSection = { key: "UiMeet3D", content: <Link to="/ui-meet-3d">Meet</Link> };
    const sections = {
      [UiMeet3dNav.HOME]: { key: "home", content: t("home") },
      [UiMeet3dNav.GENERAL]: { key: "general", content: t("general") },
      [UiMeet3dNav.GREETING_BOT]: { key: "notifications", content: t("clientPanelMisc:greetingBot") },
      [UiMeet3dNav.NOTIFICATIONS]: { key: "greetingBot", content: t("clientPanelMisc:notifications") },
      [UiMeet3dNav.EVENTS]: { key: "events", content: t("clientPanelMisc:events") },
      [UiMeet3dNav.LEADS]: { key: "leads", content: t("clientPanelMisc:leads") },
      [UiMeet3dNav.COMPLETED_MEETINGS]: { key: "meetings", content: t("clientPanelMisc:meetings") },
    };

    return [baseSection, sections[active]];
  }

  render() {
    const { t } = this.props;

    return (
      <>
        <Grid.Row className="tour-header-breadcrumb-container">
          <Grid.Column width={16}>
            <Breadcrumb icon="right angle" sections={this.getSections()} />
          </Grid.Column>
        </Grid.Row>
        <div className="tour-header-main-container">
          <div className="tour-header-controls-container">
            <div className="tour-header-status-container" />
          </div>
          <div className="tour-header-address-container">
            <h1>{t("uiMeet3d")}</h1>
          </div>
        </div>
      </>
    );
  }
}

UiMeet3dHeader.propTypes = {
  active: PropTypes.oneOf([
    UiMeet3dNav.HOME,
    UiMeet3dNav.GENERAL,
    UiMeet3dNav.GREETING_BOT,
    UiMeet3dNav.NOTIFICATIONS,
    UiMeet3dNav.EVENTS,
    UiMeet3dNav.LEADS,
    UiMeet3dNav.COMPLETED_MEETINGS,
  ]).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(UiMeet3dHeader);
